import { NgModule } from '@angular/core';
import { provideClientHydration, withIncrementalHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { SharedWebstoreModule } from 'lib/modules/shared-webstore.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { HeaderContactbarComponent } from './header/header-contactbar/header-contactbar.component';
import { HeaderMenuComponent } from './header/header-menu/header-menu.component';
import { HeaderSearchComponent } from './header/header-search/header-search.component';
import { ResourceCenterHeaderComponent } from './cms/blog/resource-center-header/resource-center-header.component';
import { ResourceCenterDropdownComponent } from './cms/blog/resource-center-dropdown/resource-center-dropdown.component';
import { ButtonModule } from './components/button/button.module';
import { HomeButtonModule } from './components/home-button/home-button.module';
import { MaterialModule } from 'lib/modules/material.module';

import { SpecialModule } from 'lib/modules/special.module';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { ServicesInitializer } from './app.initializers';
import { appPageTitles } from './app-page-titles';
import { environment } from '../environments/environment';

@NgModule({
    declarations: [
        AppComponent,
        FooterComponent,
        HeaderComponent,
        HeaderContactbarComponent,
        HeaderMenuComponent,
        HeaderSearchComponent,
        ResourceCenterHeaderComponent,
        ResourceCenterDropdownComponent,
    ],
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        MaterialModule,
        SpecialModule.forRoot(environment),
        SharedWebstoreModule.forRoot(environment, appPageTitles),
        ButtonModule,
        HomeButtonModule,
    ],
    providers: [ServicesInitializer, BsModalRef, provideClientHydration(withIncrementalHydration())],
    bootstrap: [AppComponent],
})
export class AppModule {}
